
let swiperInit = false;

export const loadSwiper = () => {
    if (swiperInit) {
        return new Promise((resolve) => {
            waitForSwiper(resolve);
        });
    }

    return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = 'https://cdn.jsdelivr.net/npm/swiper@12/swiper-bundle.min.js';
        script.async = true;

        script.onload = () => {
            if (typeof window.Swiper !== 'undefined') {
                resolve(window.Swiper);
            }
        };
        script.onerror = () => {
            swiperInit = false;
            reject(new Error(`Failed to load swiper`));
        };

        swiperInit = true;
        document.head.appendChild(script);
    });
};

const waitForSwiper = (resolve, timeout = 10000) => {
    const start = Date.now();

    function check() {
        if (typeof window.Swiper !== 'undefined' && typeof resolve === 'function') {
            resolve(window.Swiper);
            return;
        }

        if (Date.now() - start > timeout) {
            swiperInit = false;
            return;
        }

        setTimeout(check, 50);
    }

    check();
};

export default {
    loadSwiper,
    waitForSwiper,
};
